export default {
    namespaced:true,
    state: {
        token: '',
        clienteId: '',
        clienteNombre: '',
        sucursales: [],
        listaDePrecio: ''
    },

    mutations: {
      save (state, sesion) {
        state.token = sesion.token
        state.clienteId = sesion.clienteId
        state.clienteNombre = sesion.clienteNombre
      },


      delete (state) {
        state.token = ''
        state.clienteId = ''
        state.clienteNombre = ''
        state.sucursales= []
      },

      saveSucursales (state, sucursales) {
        state.sucursales = sucursales
      },

      saveListaDePrecio (state, id) {
        state.listaDePrecio = id
      }


    }

}



// WEBPACK FOOTER //
// ./src/store/modules/user.js